import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/discord': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M297.2 243.2C297.2 258.8 285.7 271.6 271.1 271.6 256.8 271.6 245 258.8 245 243.2S256.5 214.8 271.1 214.8C285.7 214.8 297.2 227.6 297.2 243.2zM177.7 214.8C163.1 214.8 151.6 227.6 151.6 243.2S163.3 271.6 177.7 271.6C192.3 271.6 203.8 258.8 203.8 243.2 204 227.6 192.3 214.8 177.7 214.8zM448 52.7V512C383.5 455 404.1 473.9 329.2 404.2L342.8 451.6H52.5C23.6 451.6 0 428 0 398.8V52.7C0 23.6 23.6 0 52.5 0H395.5C424.4 0 448 23.6 448 52.7zM375 295.4C375 213 338.2 146.2 338.2 146.2 301.3 118.5 266.2 119.3 266.2 119.3L262.7 123.4C306.2 136.7 326.4 155.9 326.4 155.9 265.6 122.6 194.2 122.6 135.2 148.5 125.7 152.8 120.1 155.9 120.1 155.9S141.3 135.7 187.4 122.4L184.8 119.3S149.8 118.5 112.9 146.2C112.9 146.2 76 213 76 295.4 76 295.4 97.5 332.5 154.1 334.3 154.1 334.3 163.6 322.8 171.3 313.1 138.8 303.4 126.5 282.9 126.5 282.9 130.2 285.5 136.4 288.9 137 289.3 180.2 313.5 241.5 321.4 296.7 298.2 305.7 294.9 315.6 290 326.1 283.1 326.1 283.1 313.3 304.1 279.8 313.6 287.5 323.3 296.7 334.3 296.7 334.3 353.3 332.5 375 295.4 375 295.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/discord.js
// module id = wt+/
// module chunks = 144